
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M241.4 500c0-13.2-.9-26.4.1-39.5.9-12-2.8-21.1-10.6-30.2-8-9.4-15.6-18.4-24.2-27.3-28.2-29.3-40-79.3-27-118.1 6-17.8 21.4-28.9 39.4-32.5.8-.2 1.6-.4 2.9-.7V246c0-46.7 0-93.4-.1-140.1 0-9.2 2.3-17.5 9.3-23.7 8.9-8 19.2-10.1 30.3-5.4 11.9 5.1 17.6 14.6 17.6 27.4.1 33.8 0 67.7 0 101.5v6.8c7-17.1 18.4-25.2 35.7-21.2 14.6 3.4 19.7 12.7 21.4 36.2 9.4-17.5 19.3-24.3 33.4-21.2 20.6 4.6 24.8 20.1 24.4 38.6.5-1.2 1-2.5 1.6-3.7 5.6-12.2 18.9-19.1 31.8-16.3 13.2 2.9 22.7 13.9 22.7 27.4l.3 93.5c0 8.5.1 17-1.9 25.2-3.1 12.6-12.8 24.3-19.6 35.3-4.4 7.2-8.9 14.5-13.3 21.7-3.8 6.2-9.2 12.5-10.1 19.6-2.2 16.9-.2 35.3-.3 52.3-54.4.1-109.1.1-163.8.1z"}}),_c('path',{attrs:{"d":"M307.6 140.8v-35.9c-.1-31.8-21.6-55.9-53.1-58.5-30.8-2.5-60.1 21.5-60.6 56.8-.2 10.7 0 21.5 0 32.2v5.6c-16.9-12.6-31-45.1-23.8-76.9C178 29.3 209 2.5 244.9.2c36.6-2.4 70 19.3 82.9 53.6 12.6 33.8-.1 69.8-20.2 87zM2.4 57.5C20.7 39.3 39.2 20.7 57.6 2.4c6.3 6.4 13 13 20.2 20.3-6.5 6.1-13.4 12.5-20.3 19 .3.4.6.9.8 1.3h80.9v29.2H57c7.9 7.3 14.7 13.7 21.1 19.7-7.7 7.7-14.4 14.4-20.8 20.9-18.1-18.4-36.6-37-54.9-55.3zm439.8 54.9c-5.9-5.9-12.5-12.6-19.4-19.6 6.4-6.1 13.2-12.6 20-19-.3-.5-.5-.9-.8-1.4h-80.9V43.3H442c-7.1-6.9-13.8-13.4-20.2-19.7l21.3-21.3C461.2 20.5 479.7 39 497.6 57l-55.4 55.4z"}})])
          )
        }
      }
    